import React from "react";
import { Route, Switch } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import AboutUsSection2 from "../Views/AboutUs/AboutUs2";
import CareerPrivacyPage from "../Views/Careers/CareerPrivacyPage";
import CareersPage from "../Views/Careers/CareersPage";
import ConstructionPage from "../Views/ConstructionPage/CounstructionHome";
import HomePage from "../Views/HomePage";
import RealEstate from "../Views/RealEstate/RealEstate";
import ConstructionDetails from "../components/ConstructionSection/constructionDetails";
import RealEstateDetails from "../components/RealEsateSection/RealEstateDetails";

// Keep page-level routes together so the app shell stays independent of page composition.
const AppRoutes = ({ setIsFormOpen, onSuccess }) => {
  const location = useLocation();
  const isCareerFlow = ["/careers", "/careers/privacy"].includes(
    location.pathname
  );

  return (
    <>
      {isCareerFlow && (
        <Box
          sx={{ display: location.pathname === "/careers" ? "block" : "none" }}
        >
          <CareersPage onSuccess={onSuccess} />
        </Box>
      )}
      <Switch>
        <Route exact path="/">
          <HomePage setIsFormOpen={setIsFormOpen} />
        </Route>
        <Route path="/portfolio/:id"></Route>
        <Route path="/construction/:id">
          <ConstructionDetails />
        </Route>
        <Route path="/construction">
          <ConstructionPage />
        </Route>
        <Route path="/real-estate/:id">
          <RealEstateDetails />
        </Route>
        <Route path="/real-estate">
          <RealEstate />
        </Route>
        <Route path="/about-us">
          <AboutUsSection2 setIsFormOpen={setIsFormOpen} />
        </Route>
        <Route exact path="/careers/privacy">
          <CareerPrivacyPage />
        </Route>
        <Route exact path="/careers" />
      </Switch>
    </>
  );
};

export default AppRoutes;
